import * as aiToolkitService from '../service';

import { queryClient, useMutation, useQuery } from '../../../hooks';
import { AIToolkitCacheKeys } from '../consts';

export const useGptJob = (gptJobId?: string) => {
  const getJobDetails = useQuery({
    queryFn: async () => aiToolkitService.getGptJobDetails(gptJobId as string),
    queryKey: [AIToolkitCacheKeys.GetMyGptJobs, gptJobId],
    enabled: !!gptJobId,
  });

  const editGptJob = useMutation({
    mutationFn: aiToolkitService.editGptJob,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [AIToolkitCacheKeys.GetMyGptJobs],
      });
    },
  });

  const analyzeFeed = useMutation({
    mutationFn: aiToolkitService.analyzeFeed,
  });

  const createGptJob = useMutation({
    mutationFn: aiToolkitService.createGptJob,
  });

  const createGptJobTitlePreview = useMutation({
    mutationFn: aiToolkitService.createGptJobTitlePreview,
  });

  return {
    getJobDetails,
    editGptJob,
    analyzeFeed,
    createGptJob,
    createGptJobTitlePreview,
  };
};
